import { useTranslation } from 'react-i18next'

import { Checkbox } from '@reveni-io/reveni-ui'

const DiscardLabelsCheckbox = ({ checked, onChange }) => {
  const { t } = useTranslation()

  return (
    <Checkbox
      label={t('Marcar etiquetas antiguas como descartadas')}
      checked={checked}
      onChange={e => onChange(e.target.checked)}
    />
  )
}

export default DiscardLabelsCheckbox
